<section id="privacy-policy" class="p-5">
  <h1>PK Spot - Privacy Policy</h1>
  <p><em>Last Updated: 7th of February 2025</em></p>

  <h2>1. Introduction</h2>
  <p>
    This Privacy Policy explains how PK Spot collects, uses, and protects your
    personal information when you use the Website. By using the Website, you
    consent to the practices described herein.
  </p>

  <h2>2. Information We Collect</h2>
  <ul>
    <li>
      <strong>Personal Information:</strong> When you create an account, we may
      collect data such as your name, email address, and any other information
      you voluntarily provide.
    </li>
    <li>
      <strong>Usage Data:</strong> We collect technical data (for example, IP
      address, browser type, and device information) through server logs and
      analytics tools.
    </li>
    <li>
      <strong>User-Generated Content:</strong> Any content you post on the
      Website may include personal data, which remains your responsibility.
    </li>
  </ul>

  <h2>3. How We Use Your Information</h2>
  <ul>
    <li>To operate, maintain, and improve the Website.</li>
    <li>
      To communicate with you (for example, account-related emails, updates, and
      support).
    </li>
    <li>
      For security purposes, including protecting against unauthorized access.
    </li>
    <li>To comply with legal obligations.</li>
  </ul>

  <h2>4. Data Sharing and Third Parties</h2>
  <p>
    Your personal data is not sold to third parties. We may share your data with
    trusted service providers solely for the purpose of operating the Website.
    All such third parties are required to adhere to confidentiality and
    security standards. If required by law, we may disclose your information to
    comply with legal processes or protect our rights.
  </p>

  <h2>5. Data Retention and User Rights</h2>
  <ul>
    <li>
      <strong>Retention:</strong> We will retain your personal data only for as
      long as necessary to fulfill the purposes for which it was collected or as
      required by law.
    </li>
    <li>
      <strong>Deletion and Correction:</strong>
      <ul>
        <li>
          You have the right to request access to, correction of, or deletion of
          your personal data.
        </li>
        <li>
          To request deletion ("Right to be Forgotten"), please contact us at
          the address provided below. We will respond within the timelines
          required by applicable law.
        </li>
      </ul>
    </li>
    <li>
      <strong>Data Portability:</strong> You may request a copy of your personal
      data in a commonly used, machine-readable format.
    </li>
  </ul>

  <h2>6. Data Security</h2>
  <p>
    We use industry-standard security measures (such as encryption and secure
    servers) to protect your personal information. However, no security system
    is impenetrable; we cannot guarantee absolute security.
  </p>

  <h2>7. Cookies and Tracking</h2>
  <p>
    Our analytics solution is cookie-less, and we do not use tracking cookies on
    your device.
  </p>

  <h2>8. International Data Transfers</h2>
  <p>
    Any data transfers are conducted in compliance with applicable laws. Where
    personal data is transferred outside your country, appropriate safeguards
    will be used as required by applicable data protection regulations.
  </p>

  <h2>9. Changes to This Privacy Policy</h2>
  <p>
    This Privacy Policy may be updated periodically. The most current version
    will be posted on this page, and significant changes will be communicated
    via the Website or through direct communication when necessary.
  </p>

  <h2>10. Contact Information</h2>
  <p>
    For any questions regarding this Privacy Policy or to exercise your rights,
    please contact us at:<br />
    Email:
    <a href="mailto:contact@lukasbuehler.ch">
      contact{{ "@" }}lukasbuehler.ch </a
    ><br />
  </p>
</section>
